import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../store/store";
import { setCurrentPage } from "../store/slices/navigationSlice";

export const useRouteTracking = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Only track authenticated routes (dashboard routes)
    if (location.pathname.startsWith("/dashboard")) {
      console.log("Tracking route change:", location.pathname);
      dispatch(setCurrentPage(location.pathname));
    }
  }, [location.pathname, dispatch]);
};
